export const SCORE_MAX = 'score-max';
export const SCORE_GOOD = 'score-good';
export const SCORE_MEDIUM = 'score-medium';
export const SCORE_POOR = 'score-poor';
export const SCORE_BAD = 'score-bad';
